import type { KeyValue } from 'ngrx-forms';

import type { NGRXProgressiveFormsActions } from '../actions';
import { MarkAsSubmittableAction } from '../actions';
import type { ProgressiveFormGroupState } from '../state';

export function markAsSubmittableReducer<TValue extends KeyValue>(
  state: ProgressiveFormGroupState<TValue>,
  action: NGRXProgressiveFormsActions
): ProgressiveFormGroupState<TValue> {
  if (action.type !== MarkAsSubmittableAction.TYPE) {
    return state;
  }

  if (action.stepId !== state.id) {
    return state;
  }

  if (state.isSubmittable) {
    return state;
  }

  return {
    ...state,
    isSubmittable: true,
    isUnsubmittable: false,
  };
}
